export default __webpack_public_path__ + "static/media/2326.4f9188aa.png";